import Link from '@activebrands/core-web/components/Link';
import { ButtonData } from '@activebrands/core-web/libs/storyblok/storyblok';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import { StyletronStyle } from '@activebrands/core-web/types/styletron';
import StateButton from 'components/buttons/StateButton';

interface ButtonsListProps {
    $style?: StyletronStyle;
    buttonSelector?: string;
    buttonStyling?: StyletronStyle;
    buttons?: ButtonData[];
    fontKeys?: string | (string | null)[];
}

const ButtonsList = ({
    $style = {},
    buttons = [],
    buttonSelector,
    buttonStyling = {},
    fontKeys = ['Primary/16_100_-03', null, null, 'Primary/18_100_-3'],
}: ButtonsListProps) => {
    const [css] = useStyletron();

    if (!buttons.length) {
        return null;
    }

    return (
        <div className={css({ display: 'flex', gap: '8px', ...$style })}>
            {buttons.map((button, index) => (
                <StateButton
                    isVolatile
                    $style={{ textDecoration: 'none', ...buttonStyling }}
                    as={Link}
                    aria-label={button.ariaLabel}
                    data-selector={buttonSelector}
                    fontKeys={fontKeys}
                    key={`${button.label}-${index}`}
                    rel={button.rel}
                    theme={button.theme}
                    to={button?.url}
                    sbEditable={button.sbEditable}
                >
                    {button.label}
                </StateButton>
            ))}
        </div>
    );
};

export default ButtonsList;
